import styled from '@emotion/styled';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';

export const StyledLinkV2 = styled(LinkV2)`
  height: 100%;
  width: 100%;
  display: block;
  background-repeat: no-repeat;
`;

export const StyledImgWrapper = styled.div`
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
`;
